import React, { useState } from 'react';
import { Row, Col, Form, InputGroup } from 'react-bootstrap';
import ProductoCard from './ProductoCard';
import { useCategorias } from '../../hooks/useCategorias';

const ProductosList = ({ productos, onEdit, onDelete }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [categoriaFilter, setCategoriaFilter] = useState('');
  
  // Hook para cargar categorías
  const { categorias, loading: loadingCategorias } = useCategorias();

  const productosFiltrados = productos.filter((p) => {
    const matchNombre = p.nombre.toLowerCase().includes(searchTerm.toLowerCase());
    const matchCategoria = categoriaFilter ? p.CodCategoria === parseInt(categoriaFilter) : true;
    return matchNombre && matchCategoria;
  });

  return (
    <>
      <Row className="mb-4 g-3">
        <Col md={8}>
          <InputGroup>
            <InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Buscar producto por nombre..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col md={4}>
          <Form.Select
            value={categoriaFilter}
            onChange={(e) => setCategoriaFilter(e.target.value)}
            disabled={loadingCategorias}
          >
            <option value="">Todas las categorías</option>
            {loadingCategorias ? (
              <option>Cargando...</option>
            ) : (
              categorias.map(cat => (
                <option key={cat.id} value={cat.id}>
                  {cat.nomCategoria}
                </option>
              ))
            )}
          </Form.Select>
        </Col>
      </Row>

      <Row xs={1} md={2} lg={3} className="g-4">
        {productosFiltrados.map((producto) => (
          <Col key={producto.id}>
            <ProductoCard producto={producto} onEdit={onEdit} onDelete={onDelete} />
          </Col>
        ))}
      </Row>

      {productosFiltrados.length === 0 && (
        <div className="text-center py-5 text-muted">
          <i className="fas fa-box-open fa-3x mb-3"></i>
          <p>No se encontraron productos que coincidan con la búsqueda.</p>
        </div>
      )}
    </>
  );
};

export default ProductosList;